import { inject } from '@angular/core';
import { DepartmentApiService } from '@shared/services';
import { TableConfig, PLACEHOLDER_FUNCTIONS, TableLazyLoadParams } from '../generic-p-table.interfaces';

export const employeeDeptTableConfig = (): TableConfig => {
  const departmentApiService = inject(DepartmentApiService);

  return {
    title: 'Nhân viên theo phòng ban',
    entityName: 'nhân viên',
    service: departmentApiService,
    method: 'getEmployeesByDepartment',
    usePostMethod: true,
    usePathParameter: true,
    columns: [
      { field: 'employee.code', header: 'Mã NV', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'profile.nickname', header: 'Nickname', width: 'min-w-[100px]', sortable: false, type: 'text' },
      { field: 'employeePositions', header: 'Vị trí', width: 'min-w-[200px]', sortable: true, type: 'custom' }
    ],
    features: {
      toolbar: true,
      pagination: true
    },
    actions: [
      {
        location: 'row',
        icon: 'pi pi-users',
        tooltip: 'Chuyển team',
        severity: 'warn',
        styleClass: 'p-button-text p-button-sm p-button-warn',
        onClick: PLACEHOLDER_FUNCTIONS.CHANGE_TEAM,
        disabled: (rowData: any) => !rowData.positionId // Disable if employee has no position
      },
      {
        location: 'row',
        icon: 'pi pi-ellipsis-h',
        tooltip: 'Lịch sử team',
        severity: 'info',
        styleClass: 'p-button-text p-button-sm p-button-info',
        onClick: PLACEHOLDER_FUNCTIONS.TEAM_HISTORY,
        disabled: (rowData: any) => !rowData.positionId // Disable if employee has no position
      }
    ],
    // Extract departmentId as path parameter
    pathParameterExtractor: (departmentId: any) => {
      return departmentId ? departmentId.toString() : null;
    },

    bodyBuilder: (_params: TableLazyLoadParams, originalBaseQuery?: any, externalFilter?: any, internalFilter?: any, searchTerm?: string) => {
      const body: any = {};

      // Handle search term (orQ) - for global search across multiple fields
      if (searchTerm && searchTerm.trim()) {
        body.orQ = {
          code: searchTerm.trim(),
          'fullname': searchTerm.trim(),
          'nickname': searchTerm.trim()
        };
      }

      // Handle all filtering logic in andQ (excluding departmentId since it's now in the URL path)
      // 1. Original static filters from config
      if (originalBaseQuery && Object.keys(originalBaseQuery).length > 0) {
        if (!body.andQ) body.andQ = {};
        body.andQ = { ...body.andQ, ...originalBaseQuery };
      }

      // 2. External dependency filters (departmentId is now excluded since it's in URL path)
      if (externalFilter && Object.keys(externalFilter).length > 0) {
        if (!body.andQ) body.andQ = {};
        body.andQ = { ...body.andQ, ...externalFilter };
      }

      // 3. Internal filter toolbar filters (future feature)
      if (internalFilter && Object.keys(internalFilter).length > 0) {
        if (!body.andQ) body.andQ = {};
        body.andQ = { ...body.andQ, ...internalFilter };
      }

      return body;
    },

    // Transform dependency value - no longer includes departmentId since it's in the URL path
    onDependencyChange: (_departmentId: any) => {
      // Return empty object since departmentId is now handled as path parameter
      return {};
    }
  };
};
